<template>
  <v-form
    v-model="$storeDemandeBourse.ValidInfosPerso"
    ref="refRevenus"
    lazy-validation
  >
    <v-layout row wrap xs12>
      <v-dialog v-model="dialog" max-width="70%">
        <v-form ref="form" v-model="valid">
          <v-card>
            <v-toolbar color="secondary" dark>
              <v-toolbar-title>{{
                $storeUm6p.Label.Revenus.RenseignerRevenus +
                $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                $storeCommun.AnneeRevenus
              }}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-container grid-list-md>
                <v-alert
                  border="left"
                  colored-border
                  color="secondary"
                  elevation="1"
                >
                  {{ $storeUm6p.Label.Revenus.RenseignerTousLesChamps }}
                </v-alert>
                <v-row>
                  <v-col cols="6">
                    <label>{{
                      $storeCatalogue.AffichageCatalogue(
                        $storeCatalogue.Parente,
                        editedItem.Parente,
                        $storeCommun.ItemLang
                      )
                    }}</label>
                  </v-col>
                  <v-col cols="6"> </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuMensuelNetDeclare }}
                    </label>
                    <br />
                    <small>
                      {{ $storeUm6p.Label.Revenus.HorsPension }}
                    </small>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RevenuNetMensuelDeclare"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetImposableAnnuelSalaire">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetAnnuelAttestation }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RevenuNetAnnuelAttestation"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetImposableAnnuelSalaire
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelSalaire">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetMensuelAttestation }}
                    </label>
                    <br />
                    <small>
                      {{
                        $storeUm6p.Label.Revenus
                          .PhraseExplicativeRevenuNetMensuelAttestation
                      }}
                    </small>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RnmAttestationSalaire"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelSalaire
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelBulletinPaieRecent">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{
                        $storeUm6p.Label.Revenus.RevenuNetMensuelBulletinRecent
                      }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RnmDernierBp"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelBulletinPaieRecent
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showRevenuNetMensuelBulletinPaieDecembre">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{
                        $storeUm6p.Label.Revenus
                          .RevenuNetMensuelBulletinDecembre
                      }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RnmBulletinPaieDec"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showRevenuNetMensuelBulletinPaieDecembre
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showSommeRevenusNetMensuelToutesPensions">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.SommeMensuelPensions }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.SommeRnmPensionsPercues"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showSommeRevenusNetMensuelToutesPensions
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showAllocationsFamiliales">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.AllocationPere }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.AllocationsFamiliales"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showAllocationsFamiliales
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showSommeRevenusNetMensuelPensions">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.PensionMere }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.SommeRnmPensionsPercuesMere"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showSommeRevenusNetMensuelPensions
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.RevenuNetAnnuelDgi }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RniAnnuelAttestationDGI"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="$storeReglesBourse.obligatoire"
                    />
                  </v-col>
                </v-row>
                <v-row v-show="showAutreRevenuNetAnnuel">
                  <v-col cols="6">
                    <label class="asterisk">
                      {{ $storeUm6p.Label.Revenus.AutreRevenuNetAnnuel }}
                    </label>
                  </v-col>
                  <v-col cols="6">
                    <VuetifyMoney
                      v-model="editedItem.RnmAutre"
                      v-bind:label="label"
                      v-bind:readonly="$storeCommun.ReadOnly"
                      v-bind:disabled="disabled"
                      v-bind:outlined="outlined"
                      v-bind:clearable="clearable"
                      v-bind:options="options"
                      :rules="
                        showAutreRevenuNetAnnuel
                          ? $storeReglesBourse.obligatoire
                          : []
                      "
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <small>
                      {{ $storeUm6p.Label.Revenus.Note1 }}
                    </small>
                    <br />
                    <small>
                      {{ $storeUm6p.Label.Revenus.Note2 }}
                    </small>
                  </v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col cols="12">
                    <v-alert
                      border="left"
                      colored-border
                      color="secondary"
                      elevation="1"
                    >
                      {{ $storeUm6p.Label.Revenus.RevenuAnnuelGlobal }}
                    </v-alert>
                    <v-simple-table>
                      <thead>
                        <tr class="text-sm-left">
                          <th>
                            {{ $storeUm6p.Label.Revenus.NatureDesRevenus }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.CAHT }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.MontantRevenuNetImp }}
                          </th>
                          <th>
                            {{ $storeUm6p.Label.Revenus.Employeur }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusProfessionnels }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.ProfessionnelsCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.ProfessionnelsNetImposable"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.ProfessionnelsEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusAgricoles }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AgricolesCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AgricolesNetImposable"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.AgricolesEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusSalariaux }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.SalariauxEtAssimilesCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                editedItem.SalariauxEtAssimilesNetImposable
                              "
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.SalariauxEtAssimilesEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusFonciers }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.FonciersCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.FonciersNetImposable"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.FonciersEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{ $storeUm6p.Label.Revenus.RevenusCapitauxImmo }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.CapitauxMobiliersCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.CapitauxMobiliersNetImposable"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.CapitauxMobiliersEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td class="asterisk">
                            {{
                              $storeUm6p.Label.Revenus.RevenusSourcesEtrangeres
                            }}
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.ProfitsEtrangersCaHt"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.ProfitsEtrangersNetImposable"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              :rules="$storeReglesBourse.obligatoire"
                              v-bind:options="options"
                            />
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.ProfitsEtrangersEmployeur"
                              :readonly="$storeCommun.ReadOnly"
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          border="left"
                          colored-border
                          color="secondary"
                          elevation="1"
                        >
                          {{
                            $storeUm6p.Label.AutresRevenus
                              .AutresRevenusAnnuelsDirham +
                            $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                            $storeCommun.AnneeRevenus
                          }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .RevenusAgricolesAnnuels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AutreRevenuDto.RevenuAgricole"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus.RevenusLocatifNef
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                editedItem.AutreRevenuDto.RevenuLocatifNet
                              "
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{ $storeUm6p.Label.AutresRevenus.Dividendes }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AutreRevenuDto.Dividendes"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .AutreRevenusNetAnnuels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AutreRevenuDto.AutresRevenus"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label
                              :class="
                                editedItem.AutreRevenuDto.AutresRevenus &&
                                editedItem.AutreRevenuDto.AutresRevenus > 0
                                  ? 'asterisk'
                                  : ''
                              "
                            >
                              {{
                                $storeUm6p.Label.AutresRevenus.PrecisezLaNature
                              }}
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="editedItem.AutreRevenuDto.NatureRevenus"
                              :readonly="$storeCommun.ReadOnly"
                              :rules="
                                editedItem.AutreRevenuDto.AutresRevenus &&
                                editedItem.AutreRevenuDto.AutresRevenus > 0
                                  ? $storeReglesBourse.obligatoire
                                  : []
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                    <v-row>
                      <v-col cols="12">
                        <v-alert
                          border="left"
                          colored-border
                          color="secondary"
                          elevation="1"
                        >
                          {{
                            $storeUm6p.Label.AutresRevenus.RevenuExceptionnels +
                            $storeUm6p.Label.AutresRevenus.AutresRevenusTitle +
                            $storeCommun.AnneeRevenus
                          }}
                        </v-alert>
                      </v-col>
                    </v-row>
                    <v-simple-table>
                      <tbody>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus.ProduitVenteImmo
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                editedItem.AutreRevenuDto.ProduitVenteBien
                              "
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label class="asterisk">
                              {{ $storeUm6p.Label.AutresRevenus.Heritages }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="editedItem.AutreRevenuDto.Heritage"
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <label class="asterisk">
                              {{
                                $storeUm6p.Label.AutresRevenus
                                  .AutresRevenusExceptionnels
                              }}
                            </label>
                          </td>
                          <td>
                            <VuetifyMoney
                              hide-details
                              dense
                              v-model="
                                editedItem.AutreRevenuDto
                                  .AutresRevenusExceptionnels
                              "
                              v-bind:label="label"
                              v-bind:readonly="$storeCommun.ReadOnly"
                              v-bind:disabled="disabled"
                              v-bind:outlined="outlined"
                              v-bind:clearable="clearable"
                              v-bind:options="options"
                              :rules="$storeReglesBourse.obligatoire"
                            />
                          </td>
                          <td>
                            <label
                              :class="
                                editedItem.AutreRevenuDto
                                  .AutresRevenusExceptionnels &&
                                editedItem.AutreRevenuDto
                                  .AutresRevenusExceptionnels > 0
                                  ? 'asterisk'
                                  : ''
                              "
                            >
                              {{
                                $storeUm6p.Label.AutresRevenus.PrecisezLaNature
                              }}
                            </label>
                          </td>
                          <td>
                            <v-text-field
                              hide-details
                              dense
                              outlined
                              v-model="
                                editedItem.AutreRevenuDto
                                  .NatureRevenusExceptionnels
                              "
                              :readonly="$storeCommun.ReadOnly"
                              :rules="
                                editedItem.AutreRevenuDto
                                  .AutresRevenusExceptionnels &&
                                editedItem.AutreRevenuDto
                                  .AutresRevenusExceptionnels > 0
                                  ? $storeReglesBourse.obligatoire
                                  : []
                              "
                            />
                          </td>
                        </tr>
                      </tbody>
                    </v-simple-table>
                  </v-col>
                </v-row>
                <!-- Tableau des crédits/financement -->
                <v-col cols="12">
                  <v-autocomplete
                    :label="$storeUm6p.Label.Parents.SituationASaisir"
                    v-model="editedItem.SituationASaisir"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="$storeReglesBourse.obligatoire"
                    class="asterisk"
                    @change="
                    changeSituation(editedItem.SituationASaisir);
                    addCredit(false)"
                  />
                </v-col>
                <v-col
                v-show="editedItem.SituationASaisir == $storeCatalogue.DataId.Oui">
                  <v-btn
                    color="secondary"
                    small
                    class="mr-2"
                    @click="addCredit(true)"
                    v-show="!$storeCommun.ReadOnly"
                  >
                    {{ $storeUm6p.Label.Ajouter }}
                  </v-btn>
                </v-col>
                <v-simple-table
                v-show="editedItem.SituationASaisir == $storeCatalogue.DataId.Oui">
                  <thead>
                    <tr>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.TypeFinancement }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.MontantGlobal }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.Duree }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.MontantEcheance }}
                      </th>
                      <th>
                        
                      </th>
                    </tr>
                  </thead>
                  <tbody v-for="(credit, index) in editedCredit" :key="credit.IdCrypte">
                    <tr v-show="!credit.Supprimer">
                      <td class="pt-6">
                        <v-autocomplete
                          :label="
                            $storeUm6p.Label.AutresRevenus.TypeFinancement
                          "
                          v-model="credit.TypeFinancement"
                          :item-text="$storeCommun.ItemLang"
                          item-value="id"
                          :items="$storeCatalogue.TypeFinancement"
                          clearable
                          outlined
                          :rules="
                            uneSituationASaisir
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          dense
                          background-color="white"
                        />
                      </td>
                      <td class="pt-6">
                        <VuetifyMoney
                          dense
                          v-model="credit.MontantGlobal"
                          v-bind:label="label"
                          v-bind:readonly="$storeCommun.ReadOnly"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:options="options"
                          :rules="
                            uneSituationASaisir
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    credit.MontantGlobal
                                  ),
                                ]
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <v-text-field
                          background-color="white"
                          v-model="credit.Duree"
                          outlined
                          dense
                          :rules="
                            uneSituationASaisir
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <VuetifyMoney
                          dense
                          v-model="credit.MontantEcheance"
                          v-bind:label="label"
                          v-bind:readonly="$storeCommun.ReadOnly"
                          v-bind:disabled="disabled"
                          v-bind:outlined="outlined"
                          v-bind:clearable="clearable"
                          v-bind:options="options"
                          :rules="
                            uneSituationASaisir
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    credit.MontantEcheance
                                  ),
                                ]
                              : []
                          "
                        />
                      </td>
                      <td class="pt-6">
                        <v-icon
                          small
                          class="mr-2"
                          v-show="!$storeCommun.ReadOnly && index > 0"
                          @click="deleteCredit(index)"
                        >
                          {{ icons.mdiDelete }}
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- FIN Tableau des crédits/financement -->
                <!-- Tableau des biens immobiliers -->
                <v-col cols="12">
                  <v-autocomplete
                    :label="
                      $storeUm6p.Label.Parents.BienImmoSecondaireParentsTuteurs
                    "
                    v-model="editedItem.BienImmoSecondaireParentsTuteurs"
                    :item-text="$storeCommun.ItemLang"
                    item-value="id"
                    :items="$storeCatalogue.OuiNon"
                    clearable
                    :rules="$storeReglesBourse.obligatoire"
                    class="asterisk"
                    @change="DisplayPopup(editedItem.BienImmoSecondaireParentsTuteurs);
                    addBienImmo(false)"
                  />
                </v-col>
                <v-dialog v-model="dialogImmo.informations.model" width="500">
                  <v-card>
                    <v-card-title>{{
                      $storeUm6p.Label.Informations
                    }}</v-card-title>
                    <v-card-text>
                      <p
                        v-html="$storeUm6p.Label.AutresRevenus.PopupNBBienImmo"
                      ></p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialogImmo.informations.model = false"
                      >
                        Fermer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-dialog v-model="dialogRevenuAlert.model" width="500">
                  <v-card>
                    <v-card-title>{{ $storeUm6p.Label.Informations }}</v-card-title>
                    <v-card-text>
                      <p>{{ dialogRevenuAlert.message }}</p>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="dialogRevenuAlert.model = false">
                        Fermer
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-col
                  v-show="
                    editedItem.BienImmoSecondaireParentsTuteurs ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <v-btn
                    color="secondary"
                    small
                    class="mr-2"
                    @click="addBienImmo(true)"
                    v-show="!$storeCommun.ReadOnly"
                  >
                    {{ $storeUm6p.Label.Ajouter }}
                  </v-btn>
                </v-col>
                <v-simple-table
                  class="table table_revenus elevation-1"
                  v-show="
                    editedItem.BienImmoSecondaireParentsTuteurs ==
                    $storeCatalogue.DataId.Oui
                  "
                >
                  <thead>
                    <tr>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NombreBiens }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NatureBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.SuperficieBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.AdresseBien }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.NumeroTitreFoncier }}
                      </th>
                      <th class="asterisk">
                        {{ $storeUm6p.Label.AutresRevenus.DateAcquisitionBien }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.ValeurAcquisitionBien
                        }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.ValeurEstimativeBien
                        }}
                      </th>
                      <th class="asterisk">
                        {{
                          $storeUm6p.Label.AutresRevenus.SourceEstimationBien
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-for="(bien, index) in editedBiensImmo"
                    :key="bien.Id"
                  >
                    <tr v-show="!bien.Supprimer">
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.NombreBiens"
                          :ref="'nombreBien' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.EstNumeriqueObligatoire
                              : []
                          "
                          :readonly="$storeCommun.ReadOnly"
                          outlined
                          dense
                        />
                      </td>
                      <td>
                        <v-autocomplete
                          background-color="white"
                          label="Nature du bien"
                          v-model="bien.NatureBien"
                          :ref="'natureBien' + index"
                          :item-text="$storeCommun.ItemLang"
                          item-value="id"
                          :items="$storeCatalogue.NatureBien"
                          clearable
                          outlined
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          dense
                          :readonly="$storeCommun.ReadOnly"
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.Superficie"
                          :ref="'superficie' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.EstNumeriqueObligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.Adresse"
                          :ref="'adresse' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.NumeroTitreFoncier"
                          :ref="'numeroTitreFoncier' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <input
                          class="dateAcquisitionClass"
                          :ref="'dateAcquisition' + index"
                          type="date"
                          v-model="bien.DateAcquisition"
                          required
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.ValeurAcquisition"
                          :ref="'valeurAcquisition' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    bien.ValeurAcquisition
                                  ),
                                ]
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.ValeurEstimative"
                          :ref="'valeurEstimative' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? [
                                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                                    bien.ValeurEstimative
                                  ),
                                ]
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-text-field
                          background-color="white"
                          v-model="bien.SourceEstimation"
                          :ref="'sourceEstimation' + index"
                          :rules="
                            estProprietairedeBiensImmo
                              ? $storeReglesBourse.obligatoire
                              : []
                          "
                          outlined
                          :readonly="$storeCommun.ReadOnly"
                          dense
                        />
                      </td>
                      <td>
                        <v-icon
                          small
                          class="mr-2"
                          v-show="!$storeCommun.ReadOnly && index > 0"
                          @click="deleteBiens(index)"
                        >
                          {{ icons.mdiDelete }}
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
                <!-- FIN Tableau des biens immobiliers -->
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn small dark color="secondary" @click="close">{{
                $storeUm6p.Label.Annuler
              }}</v-btn>
              <v-btn small dark color="secondary" @click="save">{{
                $storeUm6p.Label.Valider
              }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-dialog>
      <!-- fin dialog -->
    </v-layout>
    <v-alert
      border="left"
      colored-border
      color="secondary"
      elevation="1"
      v-show="$storeDemandeBourse.LienDocumentSalaire"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationSalarie }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeDemandeBourse.LienDocumentSalaire
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <v-alert
      border="left"
      colored-border
      color="secondary"
      elevation="1"
      v-show="$storeDemandeBourse.LienDocumentDgi"
    >
      {{ $storeUm6p.Label.Revenus.ModeleAttestationDgi }}
      <v-icon
        class="mr-2"
        :title="$storeUm6p.Label.AfficherDocument"
        @click="
          $storeCommun.AfficherAnnexe(
            $storeDemandeBourse.LienDocumentDgi
          )
        "
      >
        {{ icons.mdiFileDownload }}
      </v-icon>
    </v-alert>
    <h5>
      {{ $storeUm6p.Label.Revenus.RevenusCompleterTuteurs }}
    </h5>
    <!-- Début Liste -->
    <v-data-table
      :headers="$storeUm6p.Label.Revenus.Headers"
      :items="$storeCommun.ListeSituationsFamiliale"
      class="elevation-1"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr v-if="!item.Supprimer && item.Tuteur == $storeCatalogue.DataId.Oui">
          <th class="text-xs-left">
            {{
              $storeCatalogue.AffichageCatalogue(
                $storeCatalogue.Parente,
                item.Parente,
                $storeCommun.ItemLang
              )
            }}
          </th>
          <th>
            <v-btn small @click="editItem(item)">
              <v-icon small class="ma-2">{{ icons.mdiPencil }}</v-icon>
              {{ $storeUm6p.Label.Revenus.RenseignerRevenus }}</v-btn
            >
          </th>
        </tr>
      </template>
    </v-data-table>
    <br />
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.FraisUnivEmployeur }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="$storeCommun.InfosCandidature.FraisUniversitaire"
          ref="fraisuniv"
          :rules="$storeReglesBourse.obligatoire"
          :itemprop="$storeUm6p.Label.Parents.ChargeFraisUniv"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeCommun.ReadOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="$storeCommun.InfosCandidature.MontantFraisUniversitaire"
          :label="$storeUm6p.Label.Parents.MontantBourse"
          v-bind:readonly="$storeCommun.ReadOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          :rules="
            $storeCommun.InfosCandidature.FraisUniversitaire ==
            $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeCommun.InfosCandidature.MontantFraisUniversitaire
                  ),
                ]
              : []
          "
          ref="montantbourse"
          v-show="
            $storeCommun.InfosCandidature.FraisUniversitaire ==
            $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.CompteEpargne }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="$storeCommun.InfosCandidature.CompteEpargne"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :items="$storeCatalogue.OuiNon"
          :rules="$storeReglesBourse.obligatoire"
          ref="compteepargne"
          :itemprop="$storeUm6p.Label.Parents.CompteEpargneItem"
          :readonly="$storeCommun.ReadOnly"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="$storeCommun.InfosCandidature.MontantEpargne"
          :label="$storeUm6p.Label.Parents.MontantEpargne"
          v-bind:readonly="$storeCommun.ReadOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          :rules="
            $storeCommun.InfosCandidature.CompteEpargne ==
            $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeCommun.InfosCandidature.MontantEpargne
                  ),
                ]
              : []
          "
          ref="montantcomptesepargnes"
          v-show="
            $storeCommun.InfosCandidature.CompteEpargne ==
            $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.ValeurImmobiliere }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="$storeCommun.InfosCandidature.ValeurImmobiliere"
          ref="valeursimmo"
          :rules="$storeReglesBourse.obligatoire"
          :itemprop="$storeUm6p.Label.Parents.ValeurImmobiliereItem"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeCommun.ReadOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="$storeCommun.InfosCandidature.ValeurTotaleTitres"
          :label="$storeUm6p.Label.Parents.ValeurTotaleTitres"
          v-bind:readonly="$storeCommun.ReadOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          v-bind:rules="
            $storeCommun.InfosCandidature.ValeurImmobiliere ==
            $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeCommun.InfosCandidature.ValeurTotaleTitres
                  ),
                ]
              : []
          "
          ref="montantvaleurmobiliere"
          v-show="
            $storeCommun.InfosCandidature.ValeurImmobiliere ==
            $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <h5>
          {{ $storeUm6p.Label.Parents.DepotsTermes }}
        </h5>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <v-autocomplete
          label=""
          v-model="$storeCommun.InfosCandidature.DepotsTermes"
          ref="depotstermes"
          :rules="$storeReglesBourse.obligatoire"
          :itemprop="$storeUm6p.Label.Parents.DepotsTermesItem"
          :item-text="$storeCommun.ItemLang"
          item-value="id"
          :readonly="$storeCommun.ReadOnly"
          :items="$storeCatalogue.OuiNon"
        />
      </v-col>
      <v-col cols="6">
        <VuetifyMoney
          v-model="$storeCommun.InfosCandidature.MontantDuCapital"
          :label="$storeUm6p.Label.Parents.MontantDuCapital"
          v-bind:readonly="$storeCommun.ReadOnly"
          v-bind:disabled="disabled"
          v-bind:outlined="outlined"
          v-bind:clearable="clearable"
          v-bind:options="options"
          v-bind:rules="
            $storeCommun.InfosCandidature.DepotsTermes ==
            $storeCatalogue.DataId.Oui
              ? [
                  $storeReglesBourse.NumObli.EstNumeriqueObligatoire0(
                    $storeCommun.InfosCandidature.MontantDuCapital
                  ),
                ]
              : []
          "
          ref="montantDuCapital"
          v-show="
            $storeCommun.InfosCandidature.DepotsTermes ==
            $storeCatalogue.DataId.Oui
          "
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import VuetifyMoney from "../VuetifyMoney";
import { mdiPencil, mdiFileDownload, mdiPlusThick, mdiDelete } from "@mdi/js";
export default {
  components: {
    VuetifyMoney,
  },
  data() {
    return {
      // Param des rubriques revenus
      label: "",
      disabled: false,
      outlined: true,
      clearable: false,
      options: {
        locale: "fr-FR",
        prefix: "DH",
        suffix: "",
        length: 9,
        precision: 2,
      },

      // booleen pour affichage des blocs
      showRevenuNetImposableAnnuelSalaire: false,
      showRevenuNetMensuelSalaire: false,
      showRevenuNetMensuelBulletinPaieRecent: false,
      showRevenuNetMensuelBulletinPaieDecembre: false,
      showAutreRevenuNetAnnuel: false,
      showSommeRevenusNetMensuelToutesPensions: false,
      showAllocationsFamiliales: false,
      showSommeRevenusNetMensuelPensions: false,

      // Icon importés depuis mdi/js pour les icones d'édition/suppression
      icons: {
        mdiPencil,
        mdiFileDownload,
        mdiPlusThick,
        mdiDelete,
      },
      // Réaffecter l'objet global pour forcer la maj en temps réel
      $storeCatalogue: this.$storeCatalogue,
      $storeDemandeBourse: this.$storeDemandeBourse,
      $storeCommun: this.$storeCommun,
      $storeUm6p: this.$storeUm6p,
      // dialog pour ouvrir/fermer la popup
      dialog: false,
      dialogImmo: {
        informations: {
          model: false,
          texte: null,
        },
      },
      dialogRevenuAlert: {
        model: false,
        message: '',
      },

      // Validation du formulaire
      valid: false,

      // index de l'objet édité.
      editedIndex: -1,

      // Item local
      editedCredit: [],
      editedBiensImmo: [],
      editedItem: {
        CandidatureBourseFirsi: null,
        CandidatureBourseId: null,
        IdCrypte: null,
        IdCrypteRevenus: null,
        Supprimer: false,
        Parente: null,
        SituationProfessionnelle: null,
        Secteur: null,
        StatutParentTuteur: null,
        RevenuNetMensuelDeclare: null,
        RevenuNetMensuelDgi: null,
        LienParenteTuteur: null,
        RniAnnuelAttestationDGI: null,
        RnmAttestationSalaire: null,
        RnmDernierBp: null,
        RnmBulletinPaieDec: null,
        RnmAutre: null,
        SommeRnmPensionsPercues: null,
        AllocationsFamiliales: null,
        SommeRnmPensionsPercuesMere: null,
        // data du tableau
        ProfitsEtrangersCaHt: null,
        ProfitsEtrangersNetImposable: null,
        ProfitsEtrangersEmployeur: null,
        CapitauxMobiliersCaHt: null,
        CapitauxMobiliersNetImposable: null,
        CapitauxMobiliersEmployeur: null,
        FonciersCaHt: null,
        FonciersNetImposable: null,
        FonciersEmployeur: null,
        SalariauxEtAssimilesCaHt: null,
        SalariauxEtAssimilesNetImposable: null,
        SalariauxEtAssimilesEmployeur: null,
        AgricolesCaHt: null,
        AgricolesNetImposable: null,
        AgricolesEmployeur: null,
        ProfessionnelsCaHt: null,
        ProfessionnelsNetImposable: null,
        ProfessionnelsEmployeur: null,

        TelFixe: null,
        AdressePermanente: null,
        AdresseSecondaire: null,
        AmoTadamon: null,
        AutreRegime: null,
        NomAutreRegime: null,
        SituationASaisir: null,
        BienImmoSecondaireParentsTuteurs: null,
        NombreCompteBancaire: null,
        AssocieGerant: null,
        PreciserSociete: null,
        AutreRevenuDto: {
          Supprimer: false,
          PersonneConcernee: null,
          FinancementPropriete: null,
          CandidatureBourse: null,
          SituationFamiliale: null,
          IdCrypte: null,
          RevenuAgricole: null,
          RevenuLocatifNet: null,
          Dividendes: null,
          AutresRevenus: null,
          ProduitVenteBien: null,
          Heritage: null,
          AutresRevenusExceptionnels: null,
          NatureRevenus: null,
          NatureRevenusExceptionnels: null,
        },
        ListeBiensImmo: [],
        ListeCredits: [],
      },
    };
  },
  computed: {
    newCredit(){
      return {
        Supprimer: false,
        CandidatureBourse: this.editedItem.CandidatureBourseId,
        CandidatureBourseFirsi: this.editedItem.CandidatureBourseFirsi,
        IdCrypte: null,
        SituationFamiliale: this.editedItem.IdCrypte,
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuCredit,
        NatureBien: null,
        PersonneConcernee: this.$storeCatalogue.PersonneConcerne(
          this.editedItem.Parente
        ),
        TypeFinancement: null,
      }
    },
    newBiens(){
      return {
        Supprimer: false,
        CandidatureBourse: this.editedItem.CandidatureBourseId,
        CandidatureBourseFirsi: this.editedItem.CandidatureBourseFirsi,
        IdCrypte: null,
        SituationFamiliale: this.editedItem.IdCrypte,
        FinancementPropriete: this.$storeCatalogue.DataId.TypeRevenuPropriete,
        PersonneConcernee: this.$storeCatalogue.PersonneConcerne(
          this.editedItem.Parente
        ),
        Adresse: null,
        Duree: null,
        NombreBiens: null,
        MontantEcheance: null,
        MontantGlobal: null,
        Superficie: null,
        NatureBien: null,
        TypeFinancement: null,
        NumeroTitreFoncier: null,
        DateAcquisition: null,
        ValeurAcquisition: null,
        ValeurEstimative: null,
        SourceEstimation: null,
      };
    },
    uneSituationASaisir() {
      return (
        this.editedItem.SituationASaisir == this.$storeCatalogue.DataId.Oui
      );
    },
    estProprietairedeBiensImmo() {
      return (
        this.editedItem.BienImmoSecondaireParentsTuteurs ==
        this.$storeCatalogue.DataId.Oui
      );
    },
  },
  methods: {
    checkRevenuAlerts() {
      const situationPro = this.editedItem.SituationPro;
      const revenuMensuel = this.editedItem.RevenuNetMensuelDeclare;
      const pension = this.editedItem.SommeRnmPensionsPercues;

      // Cas 1: SituationProActif + RevenuMensuelNetDeclare = 0
      if (situationPro == this.$storeCatalogue.SituationProActif && 
          (revenuMensuel == null || revenuMensuel == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementRevenuMensuel;
        this.dialogRevenuAlert.model = true;
        return;
      }

      // Cas 2: SituationProRetraiteActif + RevenuMensuelNetDeclare = 0 ET SommeRnmPensionsPercues = 0
      if (situationPro == this.$storeCatalogue.DataId.SituationProRetraiteActif && 
          (revenuMensuel == null || revenuMensuel == 0) &&
          (pension == null || pension == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementRevenuMensuelPension;
        this.dialogRevenuAlert.model = true;
        return;
      }

      // Cas 3: SituationProRetraite + SommeRnmPensionsPercues = 0
      if (situationPro == this.$storeCatalogue.SituationProRetraite && 
          (pension == null || pension == 0)) {
        this.dialogRevenuAlert.message = this.$storeUm6p.Label.AutresRevenus.RenseignementPensionRentraite;
        this.dialogRevenuAlert.model = true;
        return;
      }
    },
    changeSituation(value) {
      if (value == this.$storeCatalogue.DataId.Non) {
        this.editedCredits.splice(0);
      }
    },
    DisplayPopup(value) {
      if (value == this.$storeCatalogue.DataId.Oui) {
        this.dialogImmo.informations.model = true;
      } 
      else if (value == this.$storeCatalogue.DataId.Non) {
        this.dialogImmo.informations.model = false;
      }
    },
    ValiderForm() {
      this.$refs.refRevenus.validate();
      let listeErreur = [];

      // Vérifier les rubriques pour chaque parent
      this.$storeCommun.ListeSituationsFamiliale.forEach((parent) => {
        let parente = this.$storeCatalogue.AffichageCatalogue(
          this.$storeCatalogue.Parente,
          parent.Parente,
          this.$storeCommun.ItemLang
        );

        if (
          parent.Tuteur == this.$storeCatalogue.DataId.Oui &&
          (parent.RevenuNetMensuelDeclare == null ||
            parent.RniAnnuelAttestationDGI == null ||
            parent.ProfessionnelsCaHt == null ||
            parent.ProfessionnelsNetImposable == null ||
            parent.AgricolesCaHt == null ||
            parent.AgricolesNetImposable == null ||
            parent.SalariauxEtAssimilesCaHt == null ||
            parent.SalariauxEtAssimilesNetImposable == null ||
            parent.FonciersCaHt == null ||
            parent.FonciersNetImposable == null ||
            parent.CapitauxMobiliersCaHt == null ||
            parent.CapitauxMobiliersNetImposable == null ||
            parent.ProfitsEtrangersCaHt == null ||
            parent.ProfitsEtrangersNetImposable == null)
        ) {
          listeErreur.push(
            this.$storeUm6p.Label.Parents.CompleterRevenus + parente
          );
        }

        if (
          parent.Tuteur == this.$storeCatalogue.DataId.Oui &&
          (!parent.SituationASaisir || !parent.BienImmoSecondaireParentsTuteurs)
        ) {
          listeErreur.push(
            this.$storeUm6p.Label.Parents.CompleterRevenus + parente
          );
        }

        if (
          parent.Tuteur == this.$storeCatalogue.DataId.Oui &&
          parent.SituationASaisir === this.$storeCatalogue.DataId.Oui &&
          parent.ListeCredits.length === 0
        ) {
          listeErreur.push(
            this.$storeUm6p.Label.Parents.AjouterCredits + parente
          );
        }

        if (
          parent.BienImmoSecondaireParentsTuteurs ===
            this.$storeCatalogue.DataId.Oui &&
          parent.ListeBiensImmo.length === 0
        ) {
          listeErreur.push(
            this.$storeUm6p.Label.Parents.AjouterBiensImmo + parente
          );
        }
      });

      Object.keys(this.$refs).forEach((key) => {
        if (key != "refRevenus" && key != "form") {
          if (
            (!this.$refs[key].valid && this.$refs[key].valid != undefined) ||
            (this.$refs[key].valid == undefined &&
              this.$refs[key].$children != undefined &&
              this.$refs[key].$children[0] != undefined &&
              !this.$refs[key].$children[0].valid)
          ) {
            let label = this.$refs[key].label;
            if (!label) {
              let inp = this.$refs[key];
              if (!inp.$attrs) {
                inp = inp[0];
              }
              label = inp.$attrs["itemprop"];
            }
            listeErreur.push(label);
          }
        }
      });
      return listeErreur;
    },
    formatNumber(number) {
      if (isNaN(number)) {
        number = "0";
      } else {
        // number = Number(number).toLocaleString(this.options.locale, {maximumFractionDigits: 2, minimumFractionDigits: 2, style: 'currency', currency: 'BRL'});
        number = Number(number).toLocaleString("pt-BR", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        });
      }
      return number.replace(",", "");
    },
    editItem(item) {
      // Récupère l'item à éditer et l'affecte à editItem local pour remplir les rubriques du formulaire popup.
      this.editedIndex =
        this.$storeCommun.ListeSituationsFamiliale.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedCredit = JSON.parse(JSON.stringify(item.ListeCredits));
      this.editedBiensImmo = JSON.parse(JSON.stringify(item.ListeBiensImmo));

      // affichage des blocs
      this.showRevenuNetImposableAnnuelSalaire =
        this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurSalarie 
        && this.editedItem.SituationPro != this.$storeCatalogue.SituationProRetraite;

      this.showRevenuNetMensuelSalaire =
        this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurSalarie 
      && this.editedItem.SituationPro != this.$storeCatalogue.SituationProRetraite;

      this.showRevenuNetMensuelBulletinPaieRecent = this.editedItem.SituationPro != this.$storeCatalogue.SituationProRetraite
      && (this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurSalarie 
          || this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurFonctionnaire);

      this.showRevenuNetMensuelBulletinPaieDecembre =
        this.editedItem.SituationPro != this.$storeCatalogue.SituationProRetraite 
          && (this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurSalarie
           || this.editedItem.SecteurActivitePro == this.$storeCatalogue.SecteurFonctionnaire);

      this.showAutreRevenuNetAnnuel = this.editedItem.SituationPro != this.$storeCatalogue.SituationProNonActif;

      this.showSommeRevenusNetMensuelToutesPensions = 
        this.editedItem.SituationPro == this.$storeCatalogue.SituationProRetraite 
        || this.editedItem.SituationPro == this.$storeCatalogue.DataId.SituationProRetraiteActif;

      this.showAllocationsFamiliales = 
        this.editedItem.Parente == this.$storeCatalogue.DataId.ParenteMere 
        && (this.editedItem.StatutParentTuteur == this.$storeCatalogue.SituationFamDivorce 
          || this.editedItem.StatutParentTuteur == this.$storeCatalogue.SituationFamDivorceRemarie);

      this.showSommeRevenusNetMensuelPensions =
        this.editedItem.Parente === this.$storeCatalogue.DataId.ParenteMere
          && this.editedItem.StatutParentTuteur === this.$storeCatalogue.SituationFamVeuf;

      // ouvre le popup
      this.dialog = true;
    },
    close() {
      // RAZ des champs du formulaire
      this.$refs.form.resetValidation();
      // ferme le popup
      this.dialog = false;
      // on remet à zéro le editedItem local
      this.editedItem = Object.assign(
        {},
        {
          CandidatureBourseFirsi: null,
          CandidatureBourseId: null,
          IdCrypte: null,
          IdCrypteRevenus: null,
          Supprimer: false,
          Parente: null,
          SituationProfessionnelle: null,
          Secteur: null,
          StatutParentTuteur: null,
          LienParenteTuteur: null,
          RevenuNetMensuelDeclare: null,
          RevenuNetMensuelDgi: null,
          RniAnnuelAttestationDGI: null,
          RnmAttestationSalaire: null,
          RnmDernierBp: null,
          RnmBulletinPaieDec: null,
          RnmAutre: null,
          SommeRnmPensionsPercues: null,
          AllocationsFamiliales: null,
          SommeRnmPensionsPercuesMere: null,
          ProfitsEtrangersCaHt: null,
          ProfitsEtrangersNetImposable: null,
          ProfitsEtrangersEmployeur: null,
          CapitauxMobiliersCaHt: null,
          CapitauxMobiliersNetImposable: null,
          CapitauxMobiliersEmployeur: null,
          FonciersCaHt: null,
          FonciersNetImposable: null,
          FonciersEmployeur: null,
          SalariauxEtAssimilesCaHt: null,
          SalariauxEtAssimilesNetImposable: null,
          SalariauxEtAssimilesEmployeur: null,
          AgricolesCaHt: null,
          AgricolesNetImposable: null,
          AgricolesEmployeur: null,
          ProfessionnelsCaHt: null,
          ProfessionnelsNetImposable: null,
          ProfessionnelsEmployeur: null,

          TelFixe: null,
          AdressePermanente: null,
          AdresseSecondaire: null,
          AmoTadamon: null,
          AutreRegime: null,
          NomAutreRegime: null,
          SituationASaisir: null,
          BienImmoSecondaireParentsTuteurs: null,
          NombreCompteBancaire: null,
          AssocieGerant: null,
          PreciserSociete: null,
          RevenuAgricole: null,
          RevenuLocatifNet: null,
          Dividendes: null,
          AutresRevenus: null,
          ProduitVenteBien: null,
          Heritage: null,
          AutresRevenusExceptionnels: null,
          NatureRevenus: null,
          AutreRevenuDto: {
            Supprimer: false,
            PersonneConcernee: null,
            FinancementPropriete: null,
            CandidatureBourse: null,
            SituationFamiliale: null,
            IdCrypte: null,
            RevenuAgricole: null,
            RevenuLocatifNet: null,
            Dividendes: null,
            AutresRevenus: null,
            ProduitVenteBien: null,
            Heritage: null,
            AutresRevenusExceptionnels: null,
            NatureRevenus: null,
            NatureRevenusExceptionnels: null,
          },
          ListeBiensImmo: [],
          ListeCredits: [],
        }
      );

      this.editedIndex = -1;
    },
    save() {
      // Vérification des alertes de revenus
      this.checkRevenuAlerts();
      if (this.dialogRevenuAlert.model) {
        return;
      }
      // validation du formulaire
      this.$refs.form.validate();
      if (!this.valid && !this.$refs.form.validate()) {
        return;
      }

      // on passe le item local à false.
      this.editedItem.Supprimer = false;

      // On affecte les liste local à l'editedItem local
      this.editedItem.ListeCredits = this.editedCredit;
      this.editedItem.ListeBiensImmo = this.editedBiensImmo;

      // on modifie l'item dans le store si l'editedIndex est renseigné.
      if (this.editedIndex > -1) {
        Object.assign(
          this.$storeCommun.ListeSituationsFamiliale[this.editedIndex],
          this.editedItem
        );
      }
      // sinon, on ajoute l'item local au store.
      else {
        this.$storeCommun.ListeSituationsFamiliale.push(this.editedItem);
      }

      // on appelle close pour raz l'item local + fermer le popup
      this.close();
    },
    addBienImmo(flag) {
      if(this.editedItem.BienImmoSecondaireParentsTuteurs === this.$storeCatalogue.DataId.Oui){
        if(flag){
          //list.push(Object.assign({}, obj));
          this.editedBiensImmo.push(Object.assign({},this.newBiens));
        }
        else if(this.editedBiensImmo.length === 0){
          this.editedBiensImmo.push(Object.assign({},this.newBiens));
        }
      }
      else{
        this.editedBiensImmo.splice(0);
      }
    },
    addCredit(flag) {
      if(this.editedItem.SituationASaisir === this.$storeCatalogue.DataId.Oui){
        if(flag){
          this.editedCredit.push(Object.assign({},this.newCredit));
        }
        else if(this.editedCredit.length === 0){
          this.editedCredit.push(Object.assign({},this.newCredit));
        }
      }
      else{
        this.editedCredit.splice(0);
      }
    },
    deleteCredit(index) {
      if (confirm(this.$storeUm6p.Label.SupprimerLigne)) {

        let credit = Object.assign({}, this.editedCredit[index]);
        credit.Supprimer = true;
        Object.assign(this.editedCredit[index], credit);
      }
    },
    deleteBiens(index) {
      if (confirm(this.$storeUm6p.Label.SupprimerLigne)) {
        let item = Object.assign({}, this.editedBiensImmo[index]);
        item.Supprimer = true;
        Object.assign(this.editedBiensImmo[index], item);
      }
    },
  },
  mounted() {
    this.$refs.refRevenus.resetValidation();
  },
};
</script>
<style scoped src="@/assets/css/DemandeBourse.css"></style>
